<template>
  <div class="moduleStyle minHeight" style="padding: 20px">页面开发中...</div>
</template>

<script>
export default {
  name: "underDevelopment",
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/underDevelopment/index.vue